import React, { useEffect } from 'react';
import { connect, useSelector } from 'react-redux';
import { cloneDeep } from 'lodash';

import { FeedPreferenceGameLocations } from '../../utils/settings';

import {
    ToggleSwitch,
    UTRRangeSliderSmall,
    AgeRangeSliderSmall,
    Select,
    Input,
} from '../Form';
import { ratingTypes } from '../../utils/constants';

const _ = { cloneDeep };

const FeedPreferencesForm = (props) => {
    const {
        formApi,
        coreUI,
        lastChangedField,
    } = props;
    const auth = useSelector(({ auth }) => auth);
    const showTennisContent = !!auth?.feedPreferences?.showTennisContent;

    const onLocationPreferenceChange = (type, val) => {
        if (val) {
            formApi.setValue('gameLocation', type);
            if (type === FeedPreferenceGameLocations.GPS) {
                formApi.setValue('gameLocationProfile', false);
            } else if (type === FeedPreferenceGameLocations.PROFILE) {
                formApi.setValue('gameLocationGps', false);
            }
        } else {
            formApi.setValue('gameLocation', null);
        }
    };

    useEffect(() => {
        const fieldsToCheck = ['showPickleballContent', 'showTennisContent'];
        const { values, setValue } = formApi;

        if (fieldsToCheck.includes(lastChangedField)) {
            const isAtleastOneSelected = fieldsToCheck.reduce((acc, field) => {
                return acc || values[field];
            }, false);

            if (!isAtleastOneSelected) {
                setTimeout(() => {
                    setValue(lastChangedField, true);
                }, 500);
            }
        }
    }, [formApi, lastChangedField]);

    const genderTypes = _.cloneDeep(coreUI.types.tms.genderTypes);
    genderTypes[0].description = 'All';

    return (
        <div className="row bt mt16 pt40">
            <div className="col-md-4">
                <h5 className={`text-uppercase`}>Home Feed</h5>
            </div>
            <div className="col-md-6 mt56">
                {(!!formApi?.values?.showTennisContent || (showTennisContent && !formApi?.values?.showPickleballContent)) && (
                    <>
                        <>
                            <label>My Hitting Goals</label>
                            <UTRRangeSliderSmall
                                id={`utr`}
                                field={'utrRange'}
                            />
                        </>
                        <ToggleSwitch
                            id={'resultsCountToMyUtr'}
                            field={'resultsCountToMyUtr'}
                            formGroupCssClass={`mt16`}
                            label="Play competitive sets"
                            description={`Counts towards players ${ratingTypes.tennis}`}
                            reverse={false}
                        />
                        <ToggleSwitch
                            id={'recreationalEvents'}
                            field={'recreationalEvents'}
                            formGroupCssClass={`mt16`}
                            label="Play recreational sets"
                            description={`Doesn't Counts towards players ${ratingTypes.tennis}`}
                            reverse={false}
                        />
                        <ToggleSwitch
                            id={'nonScoringEvents'}
                            field={'nonScoringEvents'}
                            formGroupCssClass={`mt16`}
                            label="Rally"
                            description="Rally"
                            reverse={false}
                        />
                    </>
                )}

                <>
                    <label>I would like to play with</label>
                    <AgeRangeSliderSmall
                        id={`age`}
                        field={'ageRange'}
                    />
                </>
                <>
                    <label>Gender</label>
                    <Select
                        hiddenLabel={true}
                        hiddenDefault={true}
                        id={'gender'}
                        field={'gender'}
                        options={genderTypes}
                        attributeToShow={'description'}
                        attributeToSave={'value'}
                    />
                </>
                <>
                    <label>Show me games based on</label>
                    <ToggleSwitch
                        id={'gameLocationGps'}
                        field={'gameLocationGps'}
                        formGroupCssClass={`mt16`}
                        label="GPS Location"
                        description="Game Location"
                        reverse={false}
                        onChange={val => onLocationPreferenceChange(FeedPreferenceGameLocations.GPS, val)}
                    />
                    <ToggleSwitch
                        id={'gameLocationProfile'}
                        field={'gameLocationProfile'}
                        formGroupCssClass={`mt16`}
                        label="Profile Location"
                        description="Game Locations"
                        reverse={false}
                        onChange={val => onLocationPreferenceChange(FeedPreferenceGameLocations.PROFILE, val)}
                    />
                    <label>Distance (Miles)</label>
                    <Input
                        id="distance"
                        field="distance"
                        type="number"
                    />
                </>
            </div>
        </div>
    );
};

function mapStateToProps({ coreUI }) {
    return { coreUI };
}

export default connect(mapStateToProps)(FeedPreferencesForm);
